import React from 'react';
import { useSelector } from 'react-redux';
import { openInNewTab } from '../../../utils/utils';
import youtubeLogo from '../../../assets/FinalStage/youtube-logo.png';
import classes from './YouTubeLogo.module.css';


const YouTubeLogo = ({ className = '', link }) => {

  const { texts } = useSelector((state) => state.translate);

  return (
    <div className={`${classes.wrap} ${className}`} onClick={()=>openInNewTab(link)}>
      <span className={classes.liveBadge}>
        <span className={classes.liveDot} />
        Live
      </span>
      <img src={youtubeLogo} alt="YouTube" className={classes.logo} />
      <span className={classes.text}>{texts.theFinalBroadcastOnYoutube}</span>
    </div>
  );
}
export default YouTubeLogo;
